import { render, staticRenderFns } from "./EvaluacionIndex.vue?vue&type=template&id=6ff495eb"
import script from "./EvaluacionIndex.vue?vue&type=script&lang=js"
export * from "./EvaluacionIndex.vue?vue&type=script&lang=js"
import style0 from "./EvaluacionIndex.vue?vue&type=style&index=0&id=6ff495eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports